import {
    FETCH_OPEN_API_KEY_STATUS_REQUEST,
    FETCH_OPEN_API_KEY_STATUS_SUCCESS,
    FETCH_OPEN_API_KEY_STATUS_FAILED,
    CREATE_OPEN_API_KEY_REQUEST,
    CREATE_OPEN_API_KEY_SUCCESS,
    CREATE_OPEN_API_KEY_FAILED,
    DELETE_OPEN_API_KEY_REQUEST,
    DELETE_OPEN_API_KEY_SUCCESS,
    DELETE_OPEN_API_KEY_FAILED,
    UPDATE_SYNC_ACCOUNT_REQUEST,
    UPDATE_SYNC_ACCOUNT_SUCCESS,
    UPDATE_SYNC_ACCOUNT_FAILED,
    UPDATE_PERIOD_EXTENSION_REQUEST,
    UPDATE_PERIOD_EXTENSION_SUCCESS,
    UPDATE_PERIOD_EXTENSION_FAILED,
    FETCH_OPEN_API_LATEST_MONTH_USAGE_REQUEST,
    FETCH_OPEN_API_LATEST_MONTH_USAGE_SUCCESS,
    FETCH_OPEN_API_LATEST_MONTH_USAGE_FAILED,
    FETCH_OPEN_API_DAILY_USAGE_REQUEST,
    FETCH_OPEN_API_DAILY_USAGE_SUCCESS,
    FETCH_OPEN_API_DAILY_USAGE_FAILED
} from './mutation-type'

const mutations = {
    [FETCH_OPEN_API_KEY_STATUS_REQUEST]: state => {
        state.status = 'loading'
    },
    [FETCH_OPEN_API_KEY_STATUS_SUCCESS]: (state, { data }) => {
        state.hasApiKey = data.status
        state.startDate = data.startDate
        state.endDate = data.endDate
        state.token = data.token
        state.status = 'success'
    },
    [FETCH_OPEN_API_KEY_STATUS_FAILED]: (state, error) => {
        state.status = 'error'
    },
    [CREATE_OPEN_API_KEY_REQUEST]: state => {
        state.status = 'loading'
    },
    [CREATE_OPEN_API_KEY_SUCCESS]: (state, { data }) => {
        state.apiKey = data
        state.status = 'success'
    },
    [CREATE_OPEN_API_KEY_FAILED]: (state, error) => {
        state.status = 'error'
    },
    [DELETE_OPEN_API_KEY_REQUEST]: state => {
        state.status = 'loading'
    },
    [DELETE_OPEN_API_KEY_SUCCESS]: (state, { data }) => {
        state.status = 'success'
    },
    [DELETE_OPEN_API_KEY_FAILED]: (state, error) => {
        state.status = 'error'
    },
    [UPDATE_SYNC_ACCOUNT_REQUEST]: state => {
        state.status = 'loading'
    },
    [UPDATE_SYNC_ACCOUNT_SUCCESS]: (state, { data }) => {
        state.status = 'success'
    },
    [UPDATE_SYNC_ACCOUNT_FAILED]: (state, error) => {
        state.status = 'error'
    },
    [UPDATE_PERIOD_EXTENSION_REQUEST]: state => {
        state.status = 'loading'
    },
    [UPDATE_PERIOD_EXTENSION_SUCCESS]: (state, { data }) => {
        state.startDate = data.startDate
        state.endDate = data.endDate
        state.status = 'success'
    },
    [UPDATE_PERIOD_EXTENSION_FAILED]: (state, error) => {
        state.status = 'error'
    },
    [FETCH_OPEN_API_LATEST_MONTH_USAGE_REQUEST]: state => {
        state.status = 'loading'
    },
    [FETCH_OPEN_API_LATEST_MONTH_USAGE_SUCCESS]: (state, { data }) => {
        state.usage.latestMonth = data.data.sort((a, b) => a.month > b.month ? 1 : -1)
    },
    [FETCH_OPEN_API_LATEST_MONTH_USAGE_FAILED]: (state, error) => {
        state.status = 'error'
    },
    [FETCH_OPEN_API_DAILY_USAGE_REQUEST]: state => {
        state.status = 'loading'
    },
    [FETCH_OPEN_API_DAILY_USAGE_SUCCESS]: (state, { data }) => {
        state.usage.daily = data.data
    },
    [FETCH_OPEN_API_DAILY_USAGE_FAILED]: (state, error) => {
        state.status = 'error'
    }
}

export default mutations
